import {YoutubeService} from './youtube.service';

export const YoutubeInjectables: Array<any> = [
  {
    provide: YoutubeService,
    useClass: YoutubeService,
  },
];
